import { 
	GET_TRIGGERS, 
	GET_TRIGGER,
	CREATE_TRIGGER,
	UPDATE_TRIGGER,
	DESTROY_TRIGGER,
} from "./actions"

export function TriggersReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_TRIGGERS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_TRIGGER}_FULFILLED`:
		case `${CREATE_TRIGGER}_FULFILLED`:
		case `${UPDATE_TRIGGER}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_TRIGGER}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { TriggersReducer } from "modules/triggers/reducer"

// triggers:TriggersReducer,
